import styled from 'astroturf/react'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
const colorTextAction = 'var(--colorTextAction, var(--coreColorBlue700))'
const colorStrokeStandard = 'var(--colorStrokeStandard, var(--coreColorNeutral400))'
import { FlexLayout } from '@calendly/ui/components/flex-layout'
import { BodyText, TitleText } from '@calendly/ui/components/typography'

import { useFlag } from '@calendly/feature-check-react'

import Timezone from 'components/select_date_time/timezone'
import MutualAvailabilityNotice from 'components/select_date_time/mutual_availability_notice'
import { useI18n } from 'locales'
import _Container from "header-Container.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/select_date_time/flat_spotpicker/header.js?styleId=Container";
import _PaddingWrapper from "header-PaddingWrapper.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/select_date_time/flat_spotpicker/header.js?styleId=PaddingWrapper";
import _Wrapper from "header-Wrapper.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/select_date_time/flat_spotpicker/header.js?styleId=Wrapper";
import _Divider from "header-Divider.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/select_date_time/flat_spotpicker/header.js?styleId=Divider";


const Container = /*#__PURE__*/styled('div', null, {
  displayName: "Container",
  styles: _Container,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone')
  })
})

const PaddingWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "PaddingWrapper",
  styles: _PaddingWrapper,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone')
  })
})

const Wrapper = /*#__PURE__*/styled('div', null, {
  displayName: "Wrapper",
  styles: _Wrapper,
  attrs: props => ({
    ...props,
    isTablet: useDeviceType('isTablet'),
    isPhone: useDeviceType('isPhone')
  })
})

const Divider = /*#__PURE__*/styled('div', null, {
  displayName: "Divider",
  styles: _Divider
})

const Header = () => {
  const isPhone = useDeviceType('isPhone')
  const bookingAppRedesign = useFlag('booking_app_redesign', false)
  const { i18n } = useI18n()
  return (
    <Container>
      <PaddingWrapper>
        <TitleText level={2} variant="eyebrow" color={colorTextAction}>{i18n.t('booking.templates.poll.meeting_poll_label')}</TitleText>
      </PaddingWrapper>
      <FlexLayout direction="column" gap="48">
        <PaddingWrapper>
          <BodyText size={isPhone ? 'medium' : 'large'}>{i18n.t('booking.templates.poll.select_available_times')}</BodyText>
        </PaddingWrapper>
        <Wrapper>
          <Timezone isFlatSpotpicker variant={bookingAppRedesign ? 'minimal' : 'default'} />
          <div>
            <MutualAvailabilityNotice />
          </div>
        </Wrapper>
      </FlexLayout>
      <Divider />
    </Container>
  )
}

export default Header
